import NonEditableBlock from './base/non-editable-block';
import openingTag from './../../lib/computed-properties/ic-block-opening-tag';
import HtmlCleaner from '@intercom/embercom-composer/lib/html-cleaner';
import AttributeReplacer from '@intercom/embercom-composer/lib/attribute-replacer';
import { decodeUriAttributes } from '@intercom/embercom-composer/lib/attribute-encoding';
import HTMLGenerator from '@intercom/embercom-composer/lib/html-generator';
import { hash, ternaryToProperty } from '@intercom/pulse/lib/computed-properties';
import { notEmpty } from '@ember/object/computed';
import Em from 'ember';
export default NonEditableBlock.extend({
  allowedEntities: ['attribute'],
  type: 'html',
  isMedia: true,
  isHtml: true,
  setup: Em.on('init', function () {
    this.set('htmlCleaner', new HtmlCleaner());
    this.set('attributeReplacer', new AttributeReplacer(this));
    this.cleanContent();
  }),
  htmlWithInlineStyles: '',
  renderedHtml: ternaryToProperty('htmlWithInlineStyles', 'htmlWithInlineStyles', 'text'),
  openingTag: openingTag('content', 'id'),
  closingTag: '</ic-block>',
  header: null,
  footer: null,
  innerHtml: Em.computed('htmlWithInlineStyles', 'renderedHtml', 'entities.@each.{startIndex,endIndex,url,href,fallback}', function () {
    let html = this.get('htmlWithInlineStyles') ? this.get('renderedHtml') : this.renderEntities();
    return `${this.get('_zeroWidthSpace')}<div class="block-html" contenteditable="false">${html}</div>${this.get('_zeroWidthSpace')}`;
  }),
  //TODO: GJ: enitites should expose a standard CP which can be subscribed to
  serialized: hash('type', 'content', 'header', 'footer'),
  hasHtml: notEmpty('content'),
  renderEntities() {
    let text = this.get('text');
    let entities = this.get('entities');
    let generator = new HTMLGenerator(text, entities, {
      shouldEscapeContent: false,
      significantWhitespace: false
    });
    return generator.getHtml();
  },
  cleanContent: Em.observer({
    dependentKeys: ['content'],
    fn() {
      if (this.get('hasHtml')) {
        this.set('content', this.get('htmlCleaner').cleanHtml(this.get('content')));
        this.set('entities.content', Em.A());
        this.set('text', this.get('content'));
      }
      this.get('attributeReplacer').replaceAttributes();
      if (this.get('text')) {
        this.set('text', decodeUriAttributes(this.get('text')));
      }
    },
    sync: true
  })
});